import React from 'react';

const Sidebar = () => {
  const topics = [
    { category: 'Analysis', items: ['Processing', 'Results'] },
    { category: 'Tools', items: ['Upload Image', 'Settings'] },
    { category: 'Support', items: ['Documentation', 'FAQ'] },
    { category: 'Resources', items: ['Tutorials', 'Examples'] },
    { category: 'Community', items: ['Forum', 'Blog'] },
    { category: 'Development', items: ['API', 'SDK'] }
  ];

  return (
    <aside className="lg:col-span-1">
      <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6 sticky top-8">
        <h3 className="text-lg font-bold text-gray-900 mb-6">Other Research Topics</h3>
        
        <div className="grid grid-cols-2 gap-4">
          {topics.map((topic, index) => (
            <div key={index} className="space-y-2">
              <h4 className="font-semibold text-gray-800 text-sm">
                {topic.category}
              </h4>
              <ul className="space-y-1">
                {topic.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <a 
                      href="#" 
                      className="text-blue-600 hover:text-blue-800 text-sm transition-colors duration-200"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
